module.exports = __webpack_public_path__ + "public/images/partners/sup-1.1516166091401e904699165ac68d08c8.png";